import {
	API_URL,
	CLOUDINARY_NAME,
} from './const';

export const ROUTES = {
	home: '/',
	about: '/about',
	contact: '/contact',
	donate: '/donate',
	privacyPolicy: '/privacy-policy',
	coffee: '/coffee',
	patreon: '/patreon',
	discord: '/discord',
	crashCourse: '/crash-course',
	register: '/register',
	termsOfService: '/terms-of-service',
	verify: '/verify',
	login: '/login',
	user: '/user',
	userId: '/user/:id',
	resendVerification: '/resend-verification',
	forgotPassword: '/forgot-password',
	resetPassword: '/reset-password',
	forum: '/forum',
	forumPost: '/forum/:post_id',
	forumPostNew: '/forum/new',
	safePlace: '/safe-place',
	changeEmail: '/change-email',
	notifs: '/notifs',
};

export const API_ROUTES = {
	// User
	getMe: `${API_URL}/user`,
	getUser: `${API_URL}/user/:id`,
	login: `${API_URL}/user/login`,
	register: `${API_URL}/user/register`,
	verify: `${API_URL}/user/verify`,
	authenticate: `${API_URL}/auth/native/user`,
	logout: `${API_URL}/user/logout`,
	resendVerification: `${API_URL}/user/resend-verification`,
	forgotPassword: `${API_URL}/user/forgot-password`,
	resetPassword: `${API_URL}/user/reset-password`,
	userUpdateInfo: `${API_URL}/user/update-info`,
	updateUserSettings: `${API_URL}/user/update-settings`,
	changeEmail: `${API_URL}/user/change-email`,
	changePicture: `${API_URL}/user/change-picture`,
	requestUploadPicture: `${API_URL}/user/request-upload-picture`,
	changeBanner: `${API_URL}/user/change-banner`,
	// changeUsername: `${API_URL}/user/change-username`,
	userPosts: `${API_URL}/user/:id/posts`,
	userComments: `${API_URL}/user/:id/comments`,
	forumNew: `${API_URL}/forum/new`,
	forumPosts: `${API_URL}/forum`,
	forumPost: `${API_URL}/forum/:post_id`,
	forumDelete: `${API_URL}/forum/:post_id/delete`,
	forumEdit: `${API_URL}/forum/:post_id/edit`,
	forumVote: `${API_URL}/forum/:post_id/vote`,
	forumComments: `${API_URL}/forum/:post_id/comments`,
	forumCommentNew: `${API_URL}/forum/:post_id/comments/new`,
	forumCommentDelete: `${API_URL}/forum/:post_id/comments/:commentId/delete`,
	forumCommentEdit: `${API_URL}/forum/:post_id/comments/:commentId/edit`,
	authDiscordCallback: `${API_URL}/auth/discord/callback`,
	authDiscordDisconnect: `${API_URL}/auth/discord/disconnect`,
	getNotifs: `${API_URL}/notifs`,
	getUnreadCount: `${API_URL}/notifs/unread-count`,
	readNotifs: `${API_URL}/notifs/read`,
	readAllNotifs: `${API_URL}/notifs/read-all`,
	notifSub: `${API_URL}/notifs/subscribe`,
	notifUnsub: `${API_URL}/notifs/unsubscribe`,
	getNotifSubs: `${API_URL}/notifs/subscriptions`,
	adminBan: `${API_URL}/admin/ban`,
	adminUnban: `${API_URL}/admin/unban`,
	adminDeletePost: `${API_URL}/admin/forum/:post_id/delete`,

	// Auth
	authPusher: `${API_URL}/auth/pusher`,
};

export const CLOUDINARY_API_ROUTES = {
	upload: `https://api.cloudinary.com/v1_1/${CLOUDINARY_NAME}/image/upload`,
	getUpload: `https://res.cloudinary.com/${CLOUDINARY_NAME}/image/upload/:folder/:name`,
};
